module.exports = __webpack_public_path__ + "static/media/5.58017d3c.jpg";